<template>
  <div>
    <custom-callout
      apply-border-top
      has-border
      has-toggle
      has-gradient
      controlled
      :opened="item.isOpen"
      @click:open="handleToggle(item)"
    >
      <div class="row justify-content-center align-items-center py-2">
        <div class="col-12 col-md-3">
          <custom-input-display
            label="Estudiante:"
            label-class="text-gray font-weight-light font-14"
            :value="`${item.studentSieId} - ${item.studentName}`"
            class="span-student ml-0"
          />
        </div>
        <div class="col-12 col-md-1 mt-3 mt-md-0">
          <custom-input-display label="Edad:" label-class="text-gray
          font-weight-light font-14"" :value="item.studentAge"
          class="span-student ml-0" />
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <custom-input-display label="Servicio:" label-class="text-gray
          font-weight-light font-14"" :value="item.disciplineTypeName"
          class="span-student ml-0" />
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <custom-input-display label="Tipo de Lugar:" label-class="text-gray
          font-weight-light font-14"" :value="item.locationTypeName"
          class="span-student ml-0" />
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0">
          <custom-input-display label="Lugar de Servicio:"
          label-class="text-gray font-weight-light font-14""
          :value="item.locationName" class="span-student ml-0" />
        </div>
        <div class="col-12 col-md-2 mt-3 mt-md-0 d-flex justify-content-center">
          <action-button
            i="fas fa-file-import"
            text="Entrar"
            variant="outline-success px-4"
            @click="handleEnter"
          />
        </div>
      </div>
      <template #edition>
        <div class="bg-gray p-2">
          <search-result-general-info :item="item.details" />
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';

// services
import { getRequestDetails as _getRequestDetails } from '@/services/pei/visit-registry.js';

//mixins
import mixAlert from '@/mixin/alert.mixin';

// child components
import SearchResultGeneralInfo from './SearchResultGeneralInfo.vue';

export default {
  name: 'SearchVisitResult',
  components: {
    CustomCallout,
    CustomInputDisplay,
    ActionButton,
    SearchResultGeneralInfo,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    studentSieId() {
      return this.item.studentSieId;
    },
  },
  methods: {
    async handleToggle() {
      if (!this.item.isOpen) {
        const response = await _getRequestDetails(this.studentSieId).catch(
          (error) => {
            this.ShowToast('Error', error.message, 'error');
          }
        );
        if (response?.data) {
          this.item.details = response.data;
        }
      }
      this.item.isOpen = !this.item.isOpen;
      this.$emit('toggle', { ...this.item }, this.index);
    },
    handleEnter() {
      this.$emit('enter', this.item);
    },
  },
};
</script>
